import { render, staticRenderFns } from "./FacebookPostMatch.vue?vue&type=template&id=4164896e&scoped=true&"
import script from "./FacebookPostMatch.vue?vue&type=script&lang=js&"
export * from "./FacebookPostMatch.vue?vue&type=script&lang=js&"
import style0 from "./FacebookPostMatch.vue?vue&type=style&index=0&id=4164896e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4164896e",
  null
  
)

export default component.exports